import { combineReducers } from 'redux';
import auth from './auth';
import companies from './companies';
import realityMesh from './realityMesh';
import assets from './assets';
import pointCloud from './pointCloud';
import documentCategories from './documentCategories';
import inspection from './inspection';
import annotations from './annotations';
import image360 from './360image';
import report from './report';

export default combineReducers({
  auth,
  companies,
  realityMesh,
  assets,
  pointCloud,
  documentCategories,
  inspection,
  annotations,
  image360,
  report,
});
